export const CREATE_CHECKOUT_SESSION_REQUEST = 'create_checkout_session_request';
export const CREATE_CHECKOUT_SESSION_SUCCESS = 'create_checkout_session_success';
export const CREATE_CHECKOUT_SESSION_FAILURE = 'create_checkout_session_failure';

export const CREATE_CUSTOMER_PORTAL_REQUEST = 'create_customer_portal_request';
export const CREATE_CUSTOMER_PORTAL_SUCCESS = 'create_customer_portal_success';
export const CREATE_CUSTOMER_PORTAL_FAILURE = 'create_customer_portal_failure';